export const MAX_FILE_BYTES = 50 * 1024 * 1024; // 50 MB

export const ACCEPTED_FILE_TYPES = ['application/pdf'];

// Human-readable list of what's accepted, for validation messages.
export const ACCEPTED_FILE_LABEL = 'PDF';

export interface FileValidation {
  accepted: File[];
  errors: string[];
}

export const validateFiles = (files: File[]): FileValidation => {
  const accepted: File[] = [];
  const errors: string[] = [];

  files.forEach((file) => {
    if (!ACCEPTED_FILE_TYPES.includes(file.type)) {
      errors.push(
        `${file.name} isn't a supported file type. Only ${ACCEPTED_FILE_LABEL} files are supported.`,
      );
    } else if (file.size > MAX_FILE_BYTES) {
      errors.push(`${file.name} is larger than 50 MB, the maximum file size.`);
    } else {
      accepted.push(file);
    }
  });

  return { accepted, errors };
};
